import { ChangeDetectionStrategy, Component, ElementRef, inject, signal } from '@angular/core';
import { animate, style, transition, trigger } from '@angular/animations';
import { PageHeaderBackSwipeConfig, PageHeaderComponent } from '@app/components/page-header/page-header.component';
import { ActivitySectionDirective, UserActivityClickTrackingDirective } from '@core';
import { ReviewComponent } from '@app/pages/main-page/more/review/review.component';
import { MorePartiesComponent } from '@app/pages/main-page/more/more-parties/more-parties.component';
import { MoreReservationsComponent } from '@app/pages/main-page/more/more-reservations/more-reservations.component';
import { MoreGroupEventsComponent } from '@app/pages/main-page/more/more-group-events/more-group-events.component';
import { MoreMembershipComponent } from '@app/pages/main-page/more/more-membership/more-membership.component';
import { MoreLeagueBowlingComponent } from '@app/pages/main-page/more/more-league-bowling/more-league-bowling.component';

type State = 'main' | 'parties' | 'reservations' | 'booking' | 'membership' | 'bowling' | 'review';

@Component({
  selector: 'app-page-more',
  styleUrl: './more.component.scss',
  templateUrl: './more.component.html',
  imports: [
    PageHeaderComponent,
    ActivitySectionDirective,
    UserActivityClickTrackingDirective,
    ReviewComponent,
    MorePartiesComponent,
    MoreReservationsComponent,
    MoreGroupEventsComponent,
    MoreMembershipComponent,
    MoreLeagueBowlingComponent,
  ],
  host: {
    'class': 'page',
  },
  animations: [
    trigger('InOutAnimation', [
      transition(':enter', [
        style({ transform: 'translateX(100%)' }),
        animate('400ms ease-in-out', style({ transform: 'translateX(0%)' })),
      ]),
      transition(':leave', [
        animate('400ms ease-in-out', style({ transform: 'translateX(100%)' })),
      ]),
    ]),
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MoreComponent {

  private readonly elementRef = inject<ElementRef<HTMLElement>>(ElementRef);

  protected readonly backSwipeConfig: PageHeaderBackSwipeConfig = {
    direction: 'vertical',
    element: this.elementRef.nativeElement,
  };

  public readonly state = signal<State>('main');

}
